import { useContext } from 'react';

import DialogOverrideContext from './dialogOverrideContext';

const EMPTY_OVERRIDE = Object.freeze({});

/**
 * Read the per-app override for a given dialog id. Returns a frozen empty
 * object when no override is registered, so call sites can safely destructure
 * with default fallbacks.
 *
 * @param {string} id
 * @returns {import('./dialogOverrideContext').DialogOverride}
 */
const useDialogOverride = id => {
  const registry = useContext(DialogOverrideContext);
  return registry[id] ?? EMPTY_OVERRIDE;
};

export default useDialogOverride;
